import React, {useEffect} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsGelaender,
        updateWrapperIndexGelaender,
        updateGlasartGelaender
        } from '../../../../store/actions/gelaender';
import {glastoenung} from '../../../../../assets/images/data';


const Step_Glas = (props) => {

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
        const {glasart} = props.data[props.modell_type];
        let glasart_wrapper = document.querySelectorAll('.glasArtWrapperItems');
        let glasart_index = props.data[props.modell_type].wrapper[0].wrapper5;

        //remove check from box
        for (let i = 0; i < glasart_wrapper.length; i++) {
            glasart_wrapper[i].classList.remove('check');
        }
        //add check to box
        if(glasart && glasart_wrapper[glasart_index]) {
            glasart_wrapper[glasart_index].classList.add('check');
        }

        //update steps
        props.updateSteps(7);

        if(glasart || props.data[props.modell_type].allVisitedSteps) {
            //update steps
            props.updateSteps(8);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }

   }

   const updateGlasart = ev => {
        let glasart = ev.currentTarget.getAttribute('titel');
        let wrapperObject = {
            ident: 5,
            index: ev.currentTarget.getAttribute('index')
         }

        props.updateGlasart(glasart);
        props.updateWrapperIndex(wrapperObject);
        updateItems();
   }


    return (
        <div className="step_wrapper">
              <div className="step_icon_wrapper befestigungs_wrapper">
                <h2 className='step_header handlauf'>Welche Glastönung?</h2>
                <div className="inner-befestigungs-wrapper">
                    {glastoenung.map((elem, index) => (
                        <div style={{background: `#${elem.color}`}} className="glasArtWrapperItems" onClick={updateGlasart} key={index} index={index} titel={elem.titel}>
                            <p style={elem.titel === 'Anthrazit'? {color: 'white', margin: '0'}:{color: '#212529', margin: '0'}}>{elem.titel}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        modell_type: state.gelaenderReducer.modell_type,
        data: state.gelaenderReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsGelaender(ev)),
      updateWrapperIndex: ev => dispatch(updateWrapperIndexGelaender(ev)),
      updateGlasart: ev => dispatch(updateGlasartGelaender(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_Glas);
